import { LanguageMapped } from '@/composables/globalData/useLanguages'
import env from '@/env'

export const TIME_LINE_TIMESTAMP = {
    DAY: 1000 * 24 * 3600,
    WEEK: 1000 * 24 * 3600 * 7,
    MONTH: 1000 * 24 * 3600 * 30,
}

export const DAY = TIME_LINE_TIMESTAMP.DAY
export const HOUR = TIME_LINE_TIMESTAMP.DAY / 24
export const MINUTE = HOUR / 60

export const DEFAULT_TIME_DELAY = 30


//Queue Activity Gauge suggestive word/key
export const queueActivityGaugeKey = 'GetQueuesGaugeById'

export const DEFAULT_LAYOUT_ID = 1

export const ESCAPE_KEY_CODE = 'Escape'

export const STORAGE_KEY = 'realTimeDashboardApp'
export const STORAGE_TOKEN_KEY = 'dashboardAppTokenStorageKey'
export const STORAGE_DASHBOARD_VERSION_KEY = 'dashboardVersion'
export const URL_TOKEN_PARAM = 'token'

export const DEFAULT_LANGUAGE: LanguageMapped = {
    abbName: 'EN',
    Domain: '',
    DomainConfig: {
        Direction: 'ltr'
    },
    LanguageCode: 'en-US',
    LanguageID: 1,
    LanguageName: 'English',
    locale: env.VITE_APP_I18N_LOCALE || 'en',
    name: 'En',
    icon: '/img/flags/US.png',
}
